/**
 * @bos/portal3 — the Sorvel brand: a monogram "seal" mark + the serif wordmark.
 *
 * The mark is a pine rounded tile with a serif "S" reversed out — a small, calm emblem
 * in the register of a trusted local institution (a wax seal, a good letterhead), not a
 * loud tech logo. Built in CSS (no image asset, no network dependency). Used in the app
 * header, the sign-in entry, and the standalone pages.
 */
import { Link } from 'react-router-dom';

export function Brand({
  to,
  size = 'md',
}: {
  /** When set, the brand is a link (the app header points it at the dashboard). */
  to?: string;
  size?: 'md' | 'lg';
}) {
  const className = `brand${size === 'lg' ? ' brand--lg' : ''}`;
  const inner = (
    <>
      <span className="brand__mark" aria-hidden="true">
        S
      </span>
      <span className="brand__word">Sorvel</span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className} aria-label="Sorvel — home">
        {inner}
      </Link>
    );
  }
  return (
    <span className={className} aria-label="Sorvel">
      {inner}
    </span>
  );
}
